import * as React from 'react';
var validateChildTypes = function (children, types, parent) {
  if (!children) {
    return;
  }
  var hasValidChildren = true;
  var typeNames = types.map(function (type) {
    return type.name;
  });
  var expected = function (invalid) {
    return "Invalid child type: <".concat(invalid, " />\nExpected children of <").concat(parent, " />: ").concat(typeNames.join(', '), ";");
  };
  var validate = function (child) {
    if (!child || !child.type) {
      hasValidChildren = false;
      return;
    }
    if (!typeNames.includes(child.type.name)) {
      hasValidChildren = false;
      console.error(expected(child.type.name));
    }
  };
  React.Children.forEach(children, function (child) {
    validate(child);
  });
  return hasValidChildren;
};
var validateChildTypeNames = function (children, validTypeNames, parent) {
  // If no children or production environment, skip validation.
  if (!children || process.env.NODE_ENV === 'production') {
    return;
  }
  var hasValidChildren = true;
  var expected = function (invalid) {
    return "Invalid child type: <".concat(invalid, " />\nExpected children of <").concat(parent, " />: ").concat(validTypeNames.join(', '), ";");
  };
  var validate = function (child) {
    if (!child || !child.type) {
      hasValidChildren = false;
      return;
    }
    if (!validTypeNames.includes(child.type.name)) {
      hasValidChildren = false;
      console.error(expected(child.type.name));
    }
  };
  React.Children.forEach(children, function (child) {
    validate(child);
  });
  return hasValidChildren;
};
export { validateChildTypeNames, validateChildTypes };